import { DiagnosticCategory } from "typescript";

function Header() {
  return (
    <div className="footer-container">
      <div className="text-center footer">
        <p>© 2023 - 2024 semantasoft.ir - تمامی حقوق محفوظ است</p>
      </div>
    </div>
  );
}

export default Header;
